<div class="reason-text lzl-ed" data-lzl-bg="">
  <div> <span class="re-img">
      <img (click)="img.navigation==0?imageNavigation(img.catId):link(img.navigatedUrl)" [src]="serverPath+img.img" [alt]="img.customField1" title="img.customField1" width="78" height="78"
        class=" lzl-cached lzl-ed"></span>
    <h3 [style.color]="img.customField10" [ngStyle]="{'font-family': img.customField11 || 'cursive'}" class="text"
      [ngStyle.lt-md]="{ 'font-size': item.customField17 }" [innerHTML]="img.customField1"></h3>

    <p [style.color]="img.customField15" [ngStyle]="{'font-family': img.customField16 || 'cursive'}"
      [innerHTML]="img.customField14">
    </p>
  </div>
</div>